import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/Atoms/Button/Button';
import { Prose } from '@/components/Atoms/Prose/Prose';
import { SubmittingAnimation } from '@/components/Pages/Login/SubmittingAnimation';
import { ButtonRow, LoginForm, LoginTemplate } from '@/components/Templates/LoginTemplate/LoginTemplate';
import { buildTrackingObject } from '@/services/Analytics/bbAnalyticsTrackers';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import BloombergTerminalIcon from '@bloomberg/web-icons-react/BloombergTerminal';
import Link from 'next/link';
import type { FormEvent } from 'react';
import { useState } from 'react';
import { LoginInputLabel } from './LoginInputLabel';
import styles from './LoginPage.module.css';
interface ILoginProps {
  postUrl: string;
  redirectUrl: string;
  errorKey?: string;
  statusKey?: string;
}
export const LoginPage = t0 => {
  const $ = _c(38);
  const {
    errorKey,
    statusKey,
    postUrl,
    redirectUrl
  } = t0;
  const [isSubmitting, setIsSubmitting] = useState(false);
  let t1;
  if ($[0] !== isSubmitting) {
    t1 = evt => {
      setIsSubmitting(true);
      if (isSubmitting) {
        evt.preventDefault();
      }
    };
    $[0] = isSubmitting;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSubmit = t1;
  const error = errorKey || statusKey || undefined;
  const t2 = !errorKey;
  const t3 = error ? "BNEF: Login: Error" : "BNEF: Login";
  let t4;
  if ($[2] !== t3) {
    t4 = {
      pageName: t3
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      siteSection: "BNEF: Login"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4) {
    t6 = {
      page: {
        pageInfo: t4,
        category: t5
      }
    };
    $[5] = t4;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== redirectUrl) {
    t7 = <input type="hidden" name="state" value={redirectUrl} />;
    $[7] = redirectUrl;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <LoginInputLabel>Email address{" "}<input tabIndex={1} type="email" name="email" required={true} autoFocus={true} autoComplete="email" /></LoginInputLabel>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <a href="/terms-service" target="_blank" rel="noopener noreferrer" data-analytics-tracking={buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.General, "Login: Terms of Service")}>Terms of Service</a>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span>I confirm that I have read and agree to the BNEF{" "}{t9}{" "}and{" "}<a href="/privacy-policy" target="_blank" rel="noopener noreferrer" data-analytics-tracking={buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.General, "Login: Privacy Policy")}>Privacy Policy</a>.</span>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link href="/login/contact" data-analytics-tracking={buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.General, "Login: Forgot Email")}>Forgot your registered email address?</Link>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Prose><p className={styles.terms}>{t10}{t11}<a href="/set-password" data-analytics-tracking={buildTrackingObject(TrackingAction.FollowLink, TrackingCategory.General, "Login: Set Password")}>Need to set a password for your existing account?</a></p></Prose>;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== isSubmitting) {
    t13 = isSubmitting ? <SubmittingAnimation /> : <><ButtonRow><Button kind="primary" type="submit" tabIndex={2}>Next</Button></ButtonRow><div className={styles.orLine} /></>;
    $[14] = isSubmitting;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== handleSubmit || $[17] !== postUrl || $[18] !== t13 || $[19] !== t7) {
    t14 = <LoginForm action={postUrl} onSubmit={handleSubmit}>{t7}{t8}{t12}{t13}</LoginForm>;
    $[16] = handleSubmit;
    $[17] = postUrl;
    $[18] = t13;
    $[19] = t7;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== isSubmitting) {
    t15 = isSubmitting ? {
      display: "none"
    } : {};
    $[21] = isSubmitting;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== redirectUrl) {
    t16 = <input type="hidden" name="state" value={redirectUrl} />;
    $[23] = redirectUrl;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <input type="hidden" name="method" value="bsso" />;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ButtonRow><Button kind="primary" type="submit" tabIndex={3} icon={<BloombergTerminalIcon />} className={styles.bbaButton}>Continue with BBA</Button></ButtonRow>;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== handleSubmit || $[28] !== postUrl || $[29] !== t15 || $[30] !== t16) {
    t19 = <LoginForm action={postUrl} onSubmit={handleSubmit} css={t15}>{t16}{t17}{t18}</LoginForm>;
    $[27] = handleSubmit;
    $[28] = postUrl;
    $[29] = t15;
    $[30] = t16;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== error || $[33] !== t14 || $[34] !== t19 || $[35] !== t2 || $[36] !== t6) {
    t20 = <LoginTemplate title="Login" error={error} hideDebugPanel={t2} analyticsMetadata={t6}>{t14}{t19}</LoginTemplate>;
    $[32] = error;
    $[33] = t14;
    $[34] = t19;
    $[35] = t2;
    $[36] = t6;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  return t20;
};